import styled from "styled-components";

const StyledCreateWorkoutForm = styled.div`
	padding: 0;

	.sb-create-workout-form {
		&__upload {
			margin: 32px 0;

			&__input {
				margin-bottom: 8px;
			}
		}
		textarea.ant-input {
			border-radius: 4px;
			padding: 4px 10px;
		}
		.input-field-wrapper {
			margin-bottom: 16px;
		}
		&__form {
			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: column;
			gap: 8px;

			&__button {
				width: 100%;
				max-width: unset;
				text-transform: none;
				height: 40px;
				margin-top: 16px;
			}
		}
		.ant-form-item {
			margin-bottom: 16px;
		}
	}
`;

export default StyledCreateWorkoutForm;

